import React from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import EmailSuggestion from 'Pods/Shared/EmailSuggestion/EmailSuggestion'

function EmailField({ value, onChange }) {
  // The parent hook reads event.target.value, so accepting a suggestion
  // forwards a minimal event-shaped object instead of a real DOM event.
  const handleAcceptSuggestion = (suggested) => {
    onChange({ target: { value: suggested } })
    document.getElementById('ai-sign-in-email')?.focus()
  }

  return (
    <>
      <TextInput
        id="ai-sign-in-email"
        type="primary"
        size="medium"
        label="Email"
        placeholder="john@email.com"
        value={value}
        onChange={onChange}
        wrapperClassName="ai-sign-in-modal__field"
        aria-label="Email address"
        autoFocus
        isPilot
      />
      <EmailSuggestion
        email={value}
        onAccept={handleAcceptSuggestion}
        className="ai-sign-in-modal__email-suggestion"
      />
    </>
  )
}

EmailField.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
}

export default EmailField
